module.exports = __webpack_public_path__ + "img/status-rank.9a349816.png";